export const $ = <T extends HTMLElement = HTMLElement>(id: string): T => {
  const el = document.getElementById(id);
  if (!el) throw new Error('Falta el elemento #' + id);
  return el as T;
};

/** Small element builder that only ever sets text, never HTML. */
export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  props: { class?: string; text?: string; attrs?: Record<string, string> } = {},
  children: (Node | string)[] = [],
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  if (props.class) node.className = props.class;
  if (props.text !== undefined) node.textContent = props.text;
  if (props.attrs) for (const [k, v] of Object.entries(props.attrs)) node.setAttribute(k, v);
  for (const c of children) node.append(c);
  return node;
}

export const fmt = (n: number) => n.toLocaleString('es');

export function formatDuration(ms: number): string {
  const s = Math.round(ms / 1000);
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}

export function starsEl(n: number, of = 3, size: 'small' | 'big' | '' = ''): HTMLElement {
  const wrap = el('span', { class: `stars ${size}`.trim(), attrs: { 'aria-label': `${n} de ${of} estrellas` } });
  for (let i = 0; i < of; i++) wrap.append(el('span', { class: i < n ? 'on' : '', text: '★', attrs: { 'aria-hidden': 'true' } }));
  return wrap;
}

export function statsList(target: HTMLElement, items: [string, string][]): void {
  target.replaceChildren(...items.map(([k, v]) => el('div', {}, [el('dt', { text: k }), el('dd', { text: v })])));
}
